import { render, staticRenderFns } from "./ElementDoughnutChart.vue?vue&type=template&id=2510861f&"
import script from "./ElementDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./ElementDoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports